import jsPDF from "jspdf";
import moment from "moment";
import certificateImage from "../../assets/img/course_completion_certificate.jpg";

const safeJoin = (...values) =>
    values
        .map((value) => (value == null ? "" : `${value}`.trim()))
        .filter(Boolean)
        .join(" ");

const formatDate = (value) => {
    if (!value) {
        return "-";
    }

    const formatted = moment(value);
    return formatted.isValid() ? formatted.format("MMM DD, YYYY") : "-";
};

export const generateCertificate2 = (programData, userInfo) => {
    const doc = new jsPDF({
        orientation: "landscape",
        filters: ["ASCIIHexEncode"],
    });
    const providerName = userInfo?.course?.courseOwner?.trainingCenterName || "-";
    const traineeName = userInfo?.trainee
        ? safeJoin(
            userInfo?.trainee?.firstName,
            userInfo?.trainee?.middleName,
            userInfo?.trainee?.lastName
        )
        : safeJoin(
            userInfo?.person?.firstname,
            userInfo?.person?.middlename,
            userInfo?.person?.lastname
        );
    const certificateTitle = programData?.courseTitleCat2 || "-";
    doc.addImage(certificateImage, "JPEG", 0, 0, 298, 213, undefined, "FAST");
    doc.setTextColor("#B68646");
    let pageWidth = doc.internal.pageSize.getWidth();
    doc.setFont;
    doc.text(
        pageWidth / 2 - doc.getTextWidth(providerName) / 2 + 13,
        68,
        providerName.toUpperCase()
    );
    doc.setTextColor("black");
    doc.setFontSize(15);
    userInfo.trainee ?
        (doc.text(
            120,
            102,
            traineeName || "-"
        )) : (doc.text(
            120,
            102,
            traineeName || "-"
        ))
    doc.text(
        (pageWidth / 2) - (doc.getTextWidth(certificateTitle) / 2),
        122,
        certificateTitle
    );
    doc.setFontSize(12);
    doc.text(
        80,
        135,
        `${
            "-"
        }`
    );
    doc.text(
        67,
        143,
        `${
            programData.ceu
                ? programData.ceu
                : "-"
        }`
    );
    doc.text(
        67,
        151,
        formatDate(programData.courseCompletionDate)
    );

//   doc.text(
//     188,
//     135,
//     `${
//       programData.course.courseAccreditor
//         ? programData.course.courseAccreditor.accreditorName
//           ? programData.course.courseAccreditor.accreditorName
//           : "-"
//         : "-"
//     }`
//   );
    window.open(doc.output("bloburl"));
};
